<template>
  <div class="comp-bulk-editing">
    <jw-modal :visible="data.visible" width="700px" title-align="start" @cancel="handleCancel" unmount-on-close class="lead-in comp-bulk-editing-modal" @ok="handleOk" :ok-loading="data.loading">
      <template #title>
        <div class="bulk-editing-title">
          <jw-typography-title :heading="6">{{ $t('批量修改') }}</jw-typography-title>
          <jw-typography-paragraph blockquote class="title-num">{{ $t('已选择') + (form.businessIds?.length || 0) + $t('条数据') }}</jw-typography-paragraph>
        </div>
      </template>
      <jw-form ref="bulkEditingFormRef" label-align="right" auto-label-width :model="form" @submit="handleSubmit" layout="horizontal">
        <jw-form-item :label="$t('请选择需要修改的字段')" :rules="{ required: true, message: $t('请选择需要修改的字段') }" field="fieldKey" :validate-trigger="['blur', 'input', 'change']">
          <jw-select :loading="data.loading" :field-names="{ value: 'fieldKey', label: 'fieldName' }" :trigger-props="{ updateAtScroll: true }" v-model="form.fieldKey" :placeholder="$t('请选择需要修改的字段')" :options="data.dataRange" @change="changeDataRange" allow-search> </jw-select>
        </jw-form-item>
        <jw-form-item :label="$t('修改为')" :validate-trigger="['change']">
          <jw-radio-group v-model="data.changeType">
            <jw-radio :value="0">
              {{ $t('新值') }}
            </jw-radio>
            <jw-radio :value="1" :disabled="data.changeFont?.setting?.isRequired">
              {{ $t('清空内容') }}
            </jw-radio>
          </jw-radio-group>
        </jw-form-item>

        <!-- 其他字段类型 -->
        <jw-form-item :label="$t('')" v-if="data.changeType == 0 && form.fieldKey" :rules="rules(data.changeFont)" field="fieldValue" :validate-status="data.formStatus" :help="data.errMsg" feedback :validate-trigger="['blur', 'input', 'change']">
          <template v-if="data.changeFont.value === 'opportunityStage'">
            <xl-update-fields popup-container="body" :modules="stageModulesItem(data.changeFont)" :formatData="data.form.formData" @cb="updateModulesItem" />
          </template>
          <template v-else>
            <!-- 2025年07月10日17:09:43兼容 当选择1条是传送id，其他情况传递当前拼的表单数据 -->
            <xl-association
              v-if="data.changeFont?.fieldType == 12 && form.businessIds?.length == 1"
              :basic-data="{
                id: form.businessIds?.[0],
                entity: form.entity,
                fieldKey: data.changeFont.value,
                relation: data.changeFont?.fieldExt,
                fieldValueName: ''
              }"
              :form-data="{}"
              v-model="data.changeFont.fieldValue"
              @change="updateAssociate"
            />
            <xl-update-fields v-else popup-container="body" :modules="data.changeFont" :formatData="data.form.formData" @cb="updateModulesItem" />
          </template>
        </jw-form-item>
        <jw-form-item :label="$t('是否触发自动化流程')" field="isFlowAutoProcess ">
          <jw-radio-group v-model="form.isFlowAutoProcess" :default-value="false" :options="radioOptions"> </jw-radio-group>
        </jw-form-item>
      </jw-form>
    </jw-modal>
  </div>
</template>

<script setup>
import { nextTick, reactive, ref, watch } from 'vue';
import { customService } from '@/api/';
import { tools } from '@/utils/tools';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { Message, Modal } from '@arco-design/web-vue';
import { useRichTextAiFormatProvide } from '@/hooks/rich-text-ai';
console.log('1-开始创建组件-setup');
const { loading: richTextFormatLoading } = useRichTextAiFormatProvide();
const { t } = useI18n();
const route = useRoute();
const data = reactive({
  visible: false,
  loading: false,
  formStatus: undefined,
  dataRange: [],
  customForm: [],
  viewId: undefined, //视图id
  changeFont: {},
  changeType: 0, // 修改的类型
  errMsg: '',
  getRepeat: false,
  form: {
    formData: []
  },
  inputList: [0, 1, 7, 11, 13, 16, 21, 23, 26]
});
const radioOptions = [
  { label: '是', value: true },
  { label: '否', value: false }
];
const emit = defineEmits(['cb']);
const name = ref();
const bulkEditingFormRef = ref();
const form = ref({
  entity: undefined,
  fieldKey: undefined,
  businessIds: [],
  fieldValue: undefined,
  isFlowAutoProcess: false //是否出发自动化流程
});
watch(
  () => data.changeFont.fieldValue,
  () => {
    if (data.changeFont.fieldType == 26) {
      //富文本才监听获取值
      form.value.fieldValue = data.changeFont.fieldValue;
    }
  }
);
const filterStateFont = [13, 21, 24, 27];
const filterEntryFont = {
  1: ['followUser', 'mobile', 'personName'],
  2: ['chargePerson', 'mobile', 'personName'],
  3: ['chargePerson', 'mobile', 'personName', 'opportunityStage', 'opportunityStatus'],
  6: ['chargePerson'],
  8: ['chargePerson'],
  10: ['chargePerson'],
  12: ['csmChargePerson'],
  13: ['chargePerson'],
  16: ['entityType', 'businessId'],
  99: ['businessId', 'entityType'],
  101: ['followUser', 'mobile', 'personName']
};

console.log(data, name, route);
const open = (item) => {
  resetForm();
  console.log(item);
  //列表字段 防止每次用户点击调用接口
  data.dataRange = item.listFields;
  form.value.businessIds = item?.selectTableIds || [];
  form.value.entity = item?.entity;
  data.viewId = item?.viewId;
  data.visible = true;
  nextTick(() => {
    init();
  });
};
const rules = (basic) => {
  return {
    required: true,
    validator: (value, cb) => {
      if (value) {
        // 超链接
        if (basic?.setting?.fieldType === 11 && !tools.checkLink(value)) {
          cb('格式不正确,请以http:// 或 https:// 开头,且不能包含汉字');
        }
      } else {
        cb('请完善修改后的值');
      }
    }
  };
};
const resetForm = () => {
  form.value = {
    entity: undefined,
    fieldKey: undefined,
    businessIds: [],
    fieldValue: '',
    isFlowAutoProcess: false
  };
  data.formStatus = undefined;
  data.errMsg = undefined;
  data.changeType = 0;
};
const init = async () => {
  data.loading = true;
  let _fieldList = data.dataRange.filter((dr) => !dr?.mainField && dr?.type !== 0 && filterStateFont.indexOf(dr?.fieldType) === -1 && (dr?.fieldType != 18 || !tools.isJSON(dr?.fieldExt) || JSON.parse(dr?.fieldExt)?.uploadType != 2));
  if (form.value.entity >= 200) {
    _fieldList = _fieldList.filter((item) => item?.fieldKey !== 'chargePerson');
  }
  if (filterEntryFont[form.value.entity]?.length) {
    _fieldList = _fieldList.filter((item) => filterEntryFont[form.value.entity].indexOf(item?.fieldKey) === -1);
  }
  data.loading = false;
  data.dataRange = _fieldList;
};
const handleCancel = () => {
  data.visible = false;
};

//修改数据范围
const changeDataRange = async () => {
  data.getRepeat = false;
  const _selectField = data.dataRange.find((item) => item.fieldKey === form.value.fieldKey);
  data.changeFont = {
    ..._selectField,
    //优化 25查找多选为空时 改null为'' 不然后端接口报错 2024年11月12日14:42:51 by zl
    fieldValue: _selectField?.fieldType == 25 ? _selectField?.fieldValue || '' : _selectField?.fieldValue,
    value: _selectField?.fieldKey,
    label: _selectField?.fieldName,
    type: 20,
    setting: _selectField,
    placeholder: data.inputList.includes(_selectField?.fieldType) ? t('请输入') : t('请选择')
  };
  //拼接添加form表单结构
  data.form.formData = [
    {
      modules: [data.changeFont],
      type: '10'
    }
  ];
  if (data.changeFont?.isRequired) {
    data.changeType = 0;
  }
  //修改操作类型 重渲第三个输入框
  data.changeType = 1;
  nextTick(() => {
    data.changeType = 0;
  });
  console.log(form.value.fieldKey, data.changeFont, '选中的值');
};
// 此处是处理商机阶段在新建/复制时默认选择第一个
const stageModulesItem = (item) => {
  if (item.value === 'opportunityStage' && (data.type == 30 || data.copy == 1)) {
    // 如果是复制或者新增，永远赋值第一个阶段
    const ext = item.setting.fieldExt;
    item.fieldValue = tools.isJSON(ext) && JSON.parse(ext) && JSON.parse(ext)?.length && JSON.parse(ext)?.[0]?.value;
  }
  return item;
};
/*********** 返回值处理 B ************/
const getFormFieldValue = (list) => {
  let fieldValue = list?.fieldValue;
  const fieldType = list.setting.fieldType == 21 ? list?.setting?.business?.fieldType : list.setting.fieldType;
  const fieldExt = list.setting.fieldType == 21 ? list?.setting?.business?.fieldExt : list.setting.fieldExt;
  if (fieldType === 3 || fieldType === 5) {
    fieldValue = fieldValue && Array.isArray(fieldValue) ? fieldValue?.join(',') : null;
  } else if (fieldType === 6) {
    //人员传递参数是字符串ID以逗号分割
    const userIds = list.setting?.fv?.userList?.map((u) => u.id)?.join(',');
    fieldValue = userIds || '';
  } else if (fieldType === 9) {
    const hasValue = tools.hasDateRange(fieldValue);
    const v = { beginDate: fieldValue?.[0], endDate: fieldValue?.[1] };
    fieldValue = hasValue ? JSON.stringify(v) : '';
  } else if (fieldType === 10) {
    fieldValue = fieldValue && Array.isArray(fieldValue) ? fieldValue?.join('/') : '';
  } else if (fieldType === 12) {
    fieldValue = fieldValue?.value || list?.customValue?.value || fieldValue || '';
  } else if (fieldType === 16) {
    fieldValue = tools.setPrice(fieldValue) || '';
  } else if (fieldType === 18) {
    fieldValue = fieldValue ? JSON.stringify(fieldValue) : '';
  } else if (fieldType === 23) {
    fieldValue = fieldValue ? tools.setPercentage(fieldValue) : null;
  } else if (fieldType === 22) {
    //部门传递参数是字符串ID以逗号分割
    const departIds = list.setting?.fv?.departList?.map((u) => u.id)?.join(',');
    fieldValue = departIds || '';
  }
  if (fieldType === 24) {
    //计算类型
    if (fieldExt && tools.isJSON(fieldExt)) {
      if (JSON.parse(fieldExt)?.type == 6 || JSON.parse(fieldExt)?.type == 16) {
        //6：汇总金额  16：金额
        fieldValue = tools.setPrice(fieldValue) || '';
      } else if (JSON.parse(fieldExt)?.type == 23) {
        //百分比
        fieldValue = fieldValue ? tools.setPercentage(fieldValue, JSON.parse(fieldExt)?.dataType) : '';
      }
    }
  }

  return fieldValue;
};
//2025年07月10日17:31:15 zl兼容查找关联配置条件查询不到值，并模拟调用回调接口
const updateAssociate = (id, fieldValue) => {
  const _modules = {
    ...data.changeFont,
    fieldValue: id,
    customFieldValue: fieldValue
  };
  updateModulesItem(null, _modules);
};
// 修改数据的值并查重
const updateModulesItem = async (getformatData, modulesItem) => {
  console.log(getformatData, '数据修改返回', JSON.parse(JSON.stringify(modulesItem)), '数据修改返回');
  data.getRepeat = false;
  form.value.fieldValue = getFormFieldValue(modulesItem);
  nextTick(() => {
    bulkEditingFormRef.value.validate();
  });
  console.log(getformatData, '数据修改返回2', JSON.parse(JSON.stringify(form.value.fieldValue)), '数据修改返回2');
};
/*********** 返回值处理 E ************/
const setRepeat = async () => {
  data.loading = true;
  try {
    const json = await customService.fieldVerify(form.value);
    console.log(json);
    if (!json.result) {
      data.formStatus = 'error';
      data.errMsg = t('此数据存在重复，请检查后重试');
    } else {
      data.formStatus = undefined;
      data.errMsg = undefined;
    }
    data.getRepeat = true;
    data.loading = false;
  } catch (e) {
    console.log(e);
    data.loading = false;
  }
};
const handleOk = () => {
  bulkEditingFormRef.value.handleSubmit();
};
// 左侧表单提交事件
const handleSubmit = async ({ values, errors }) => {
  console.log('handleSubmit', errors, values);
  if (richTextFormatLoading.value) {
    return Message.error(t('AI排版中...'));
  }
  if (errors) {
    data.errors = errors;
    const errorArray = {};
    Object.values(errors).forEach((key, index) => {
      errorArray[key.field] = { status: 'error', message: '' };
      Object.values(errorArray).forEach((i, ind) => {
        if (index === ind) {
          i.message = key.message;
        }
      });
    });
    bulkEditingFormRef?.value.setFields(errorArray);
    return;
  }
  console.log(data.getRepeat, 'getRepeat');
  //eslint-disable-next-line no-debugger
  // debugger;
  if (data.changeType == 0) {
    if (!data.getRepeat) {
      await setRepeat();
    }
    if (data.formStatus) {
      return;
    }
  }
  console.log('表单值', form.value);
  Modal.confirm({
    title: `${t('你确定要修改全部数据吗')}？`,
    content: t('此操作将修改全部') + (form.value?.businessIds?.length || 0) + t('条数据。数据修改后不可恢复，请谨慎操作'),
    titleAlign: 'start',
    simple: false,
    okText: t('修改'),
    onOk: () => {
      updataFile();
    }
  });
};
const updataFile = async () => {
  data.loading = true;
  try {
    // console.log(307, form.value);
    const json = await customService.fieldEdit(form.value);
    console.log(json);
    if (!json.error) {
      Message.success('批量编辑执行中，完成后将发送飞书消息通知');
    } else {
      Message.error(json.message || t('操作失败'));
    }
    data.loading = false;
    data.visible = false;
    emit('cb', { fieldKey: form.value.fieldKey, type: 'edit' });
  } catch (e) {
    console.log(e);
    data.loading = false;
    data.visible = false;
    Message.error(e.message || e.statusText || t('操作失败'));
    emit('cb', { fieldKey: form.value.fieldKey, type: 'edit' });
  }
};
defineExpose({
  open
});
</script>
<style scoped lang="less">
@import './bulk-editing.less';
</style>
<style lang="less">
.comp-bulk-editing-modal {
  .arco-modal-body {
    max-height: 400px;
  }
}
</style>
